import { render, staticRenderFns } from "./buyer-list.mpx?vue&type=template&id=7bff4f4e&scoped=true&component=true&componentId=buyer-list66698d0a"
import script from "./buyer-list.mpx?vue&type=script&lang=js&component=true&componentId=buyer-list66698d0a"
export * from "./buyer-list.mpx?vue&type=script&lang=js&component=true&componentId=buyer-list66698d0a"
import style0 from "./buyer-list.mpx?vue&type=style&index=0&id=7bff4f4e&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m66698d0a%22%7D&component=true&componentId=buyer-list66698d0a"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bff4f4e",
  null
  
)

export default component.exports